import React from 'react'
import {Card, Container, ListGroup, ListGroupItem} from 'react-bootstrap';
import juxt from './images/juxt.png';
import twitter from './images/twitter.png';

export const Projects = () => {
    return (
        <>
        {/* <h2 style={{textAlign: 'center', color: 'white', marginTop: '3.5vh'}}><strong>Projects:</strong></h2> */}
        <div style = {styles.divStyle}>
            <h2 style={{textAlign: 'center', color: 'white'}}><strong>Projects:</strong></h2>
            <Container style={{textAlign: 'center'}}>
                <img src={juxt} width='100%'/>  
            </Container>

            <Card style={styles.cardStyle}>
                <Card.Body>
                    <Card.Title><h3><strong>Juxtapose (Degree Project)</strong></h3></Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                        Juxtapose is a proudly Kenyan Fact Checking website that can be used to detect Fake News.
                        This project was built using a Machine Learning model that was trained on a Fake News Dataset.
                        This included web scraping
                        news articles to create a dataset, feature extraction on the dataset using Pandas, Numpy and Scikit-Learn and
                        training a Passive Aggressive Machine Learning model on the dataset.
                    </Card.Subtitle>
                    <Card.Text>
                        <ListGroup className="list-group-flush">
                            <ListGroupItem style={styles.techStyle}><strong>Frontend:</strong> React JS | React-Bootstrap | Redux </ListGroupItem>
                            <ListGroupItem style={styles.techStyle}><strong>Backend:</strong> Python | Flask | Twitter API</ListGroupItem>
                            <ListGroupItem style={styles.techStyle}><strong>Others:</strong> Machine Learning | Webscraping</ListGroupItem>
                            <ListGroupItem style={styles.techStyle}><strong>Link:</strong> <a href="https://github.com/jaden-lesuk/juxtapose">GitHub</a></ListGroupItem>
                        </ListGroup>
                    </Card.Text>
                </Card.Body>
            </Card>

            <Container style={{textAlign: 'center', marginBottom: '4.5vh', marginTop:'7vh'}}>
                <img src={twitter} width='70%'/>  
            </Container>

            <Card style={styles.cardStyle}>
                <Card.Body>
                    <Card.Title><h3><strong>Twitter API GUI (Freelance Work)</strong></h3></Card.Title>
                    <Card.Subtitle className="mb-2 text-muted">
                    Created a GUI Application to enable a client to acquire csv formatted data from the Twitter API based on certain
                    search queries. Requirements were collected from the client and frequent meetings were held to present deliverables.
                    The client was then trained on the usage of the software.
                    </Card.Subtitle>
                    <Card.Text>
                        <ListGroup className="list-group-flush">
                            <ListGroupItem style={styles.techStyle}><strong>Technology Used:</strong> Python | PyQt5 </ListGroupItem>
                            <ListGroupItem style={styles.techStyle}><strong>Link:</strong> <a href="https://github.com/jaden-lesuk/twitter-gui">GitHub</a></ListGroupItem>
                        </ListGroup>
                    </Card.Text>
                </Card.Body>
            </Card>

        </div></>
    )
}

const styles  = {
    divStyle: {
        marginTop: '3.5vh',
        marginBottom: '3.5vh',
    },
    cardStyle: {
        backgroundColor: 'white',
        border: 'solid 3px white',
    },
}